import { useEffect, useState } from "react";
import { Network } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { switchTenant } from "@/lib/tenant";

export const TenantSwitcher = () => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  useEffect(() => { if (user?.global_admin) api.get("/tenants").then((r) => setList(r.data)).catch(() => {}); }, [user?.global_admin]);
  if (!user?.global_admin) {
    return <div className="hidden items-center gap-2 text-xs uppercase tracking-[0.18em] text-slate-400 lg:flex" data-testid="tenant-name"><Network className="h-3.5 w-3.5" />{user?.tenant?.name || "Moduli CRM"}</div>;
  }
  const away = user.tenant?.id !== user.home_tenant;
  return (
    <div className="flex items-center gap-2" data-testid="tenant-switcher">
      <Select value={user.tenant?.id} onValueChange={(v) => switchTenant(v === user.home_tenant ? "" : v)}>
        <SelectTrigger data-testid="tenant-switcher-trigger" className={`h-9 w-44 sm:w-56 ${away ? "border-amber-300 bg-amber-50 text-amber-800" : ""}`}>
          <Network className="mr-1 h-3.5 w-3.5 shrink-0" /><SelectValue placeholder="Circuito" />
        </SelectTrigger>
        <SelectContent>
          {list.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`tenant-option-${t.slug}`}>{t.name}{t.active ? "" : " (disattivato)"}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
